module.exports = __webpack_public_path__ + "static/media/adobe-software.feb02ae1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Talent/assets/adobe-software.jpg
// module id = 554
// module chunks = 0